<template>
  <div>

    <vx-card>
      <vs-table
        class="pb-wide"
        stripe
        ref="table"
        :data="mails"
        search

        :sst="true"
        :max-items="itemsPerPage"
        @search="handleTableSearch"
        @selected="handleTableSelected">

        <template slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <vs-select id="tableSelect" autocomplete label="" v-model="itemsPerPage" class="w-1/12" @change="handleChangeTablePerPage">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in itemsPerPageOptions"/>
          </vs-select>
        </template>

        <template slot="thead">
          <vs-th class="" sort-key="groupName" >
            <vs-col vs-type="flex"  vs-justify="left" >
              No.
            </vs-col>
          </vs-th>
          <vs-th class="" sort-key="groupName" >
            <vs-col vs-type="flex"  vs-justify="center" >
              팝업제목
            </vs-col>
          </vs-th>
          <vs-th class="" >
            <vs-col vs-type="flex"  vs-justify="center" >
              사이즈
            </vs-col>
          </vs-th>
          <vs-th class="" >
            <vs-col vs-type="flex"  vs-justify="center" >
              시작일
            </vs-col>
          </vs-th>
          <vs-th class="" >
            <vs-col vs-type="flex"  vs-justify="center" >
              마감일
            </vs-col>
          </vs-th>
          <vs-th class="" >
            <vs-col vs-type="flex"  vs-justify="center" >
              상태
            </vs-col>
          </vs-th>
          <vs-th class="th-fix-management" >
            <vs-col vs-type="flex"  vs-justify="center" >
              관리
            </vs-col>
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

            <!-- NO. -->
            <vs-td >
              {{ indextr }}
            </vs-td>

            <!-- 팝업제목 -->
            <vs-td >
              {{ data[indextr].title }}
            </vs-td>

            <!-- 사이즈 -->
            <vs-td class="text-center">
              {{ data[indextr].size }}
            </vs-td>

            <!-- 시작일 -->
            <vs-td class="text-center">
              {{ data[indextr].startDate }}
            </vs-td>

            <!-- 마감일 -->
            <vs-td class="text-center">
              {{ data[indextr].endDate }}
            </vs-td>

            <!-- 상태 -->
            <vs-td class="text-center">
              {{ data[indextr].status }}
            </vs-td>

            <!-- 관리 -->
            <vs-td class="td-fix-management text-right">
              <vs-button class="" color="primary" type="border" @click="(event)=>{ handleItemClickModified(event, tr.id) }">수정</vs-button>
              <vs-button class="ml-4" color="#EDEDED" text-color="black" type="filled" @click.stop>삭제</vs-button>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>

      <div class="w-full text-right">
        <vs-button class="w-2/12" color="secondary" @click="handleFooterClickRegister">등록</vs-button>
      </div>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination
            :total="(lastPage) ? lastPage : 1"
            v-model="currentPage" @change="handleTableChangePage"></k-pagination>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import VueCookie from 'vue-cookie'
import memberModule from '@/store/member/memberModule.js'
import KPagination from '@/views/components/kPagination/kPagination'

export default {
  name:'AdminPopup',
  components: {KPagination},
  data () {
    return {
      selected: [],
      itemsPerPageOptions: [
        { text: '10', value: 10 },
        { text: '20', value: 20 },
        { text: '50', value: 50 }
      ],
      mails: [],

      // pagination
      startNo: 1,
      lastPage: 1,
      totalCount: 1,
      currentPage: 1,
      itemsPerPage: 10
    }
  },
  computed: {
  },

  created () {

    // 동적 모듈 등록
    if (!this.$store.hasModule('member')) {
      this.$store.registerModule('member', memberModule)
    }

    this.mails = [
      { title: '팝업1', size: '1024x1024', startDate: '0', endDate: '0', status:'open'},
      { title: '팝업2', size: '1024x1024', startDate: '0', endDate: '0', status:'open'},
      { title: '팝업3', size: '1024x1024', startDate: '0', endDate: '0', status:'close'}
    ]
  },
  mounted () {
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.table.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  beforeDestroy () {
    // 동적 모듈 삭제
    this.$store.unregisterModule('member')
  },

  methods: {
    loadSendMail () {

    },

    // 수정페이지로 이동
    moveModified (id) {
      // 선택한 사용자 ID 저장
      VueCookie.set(this.$store.state.member.COOKIE_KEY_CURRENT_USER_ID, id)
      this.$router.push({ path: '../popup/1/update' })
    },

    // 등록페이지로 이동
    moveRegister () {
      this.$router.push({ path: '../popup/created' })
    },


    //===== [ dev ] =====

    is_number (v) {
      const reg = /^(\s|\d)+$/
      return reg.test(v)
    },


    //===== [ handler ] ======

    handleItemClickModified (event, id) {
      this.moveModified(id)
    },
    handleFooterClickRegister () {
      this.moveRegister()
    },
    handleChangeTablePerPage (per_page) {
      if (this.is_number(per_page)) {
        this.itemsPerPage = per_page
      }
      this.currentPage = 1
      this.loadSendMail(this.currentPage)
    },
    handleTableChangePage (page) {
      this.loadSendMail(page)
    },
    handleTableSearch (keyword) {
      const page = this.currentPage
      this.loadSendMail(page, keyword)
    },
    handleTableSelected (tr) {
      if (!tr) {
        return
      }
      this.moveModified(tr.id)
    }
  }//methods
}
</script>

<style scoped>
.th-fix-management,
.td-fix-management{
  width:214px;
}

.pb-wide{ margin-bottom:1.5rem !important;}

.tip { padding:24px; background-color: #fff; }
.tip p {color:#757575}
.tip p.warning {color:red; font-weight: 500}
</style>
